import { createFileRoute } from "@tanstack/react-router";
import { ReleaseNotesPage } from "#/modules/util.release-notes/components/release-notes-page";

export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/admin/release-notes/")(
  {
    component: ReleaseNotesPage,
  },
);
